import type { FC } from 'react'

import { Input, Select, Textarea } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

export const GreenpoolSettings: FC<{ isDisabled?: boolean }> = ({ isDisabled = false }) => {
  const translate = useTranslation()

  const greenpoolOptions = [
    { value: 'OPTIONAL', label: translate('Optional') },
    { value: 'MANDATORY', label: translate('Mandatory') },
    { value: '', label: translate('Disabled') },
  ]

  return (
    <>
      <h2>
        <Translation id="Greenpool settings" />
      </h2>

      <Field name="greenpoolTypeId">
        {({ field, form }: FieldProps) => (
          <Select
            id="greenpoolTypeId"
            label={<Translation id="Greenpool state" />}
            options={greenpoolOptions}
            marginBottom={16}
            isDisabled={isDisabled}
            {...field}
            onChange={option => {
              if (!option?.value) {
                form.values.greenpoolNotificationEmail &&
                  form.setFieldValue('greenpoolNotificationEmail', '')
                form.values.greenpoolSplashText && form.setFieldValue('greenpoolSplashText', '')
                form.values.greenpoolConfirmationText &&
                  form.setFieldValue('greenpoolConfirmationText', '')
              }
              if (option?.value === 'MANDATORY') {
                form.values.greenpoolSplashText && form.setFieldValue('greenpoolSplashText', '')
              }
              form.setFieldValue(field.name, option?.value)
            }}
          />
        )}
      </Field>

      <Field name="greenpoolNotificationEmail">
        {({ field, meta, form }: FieldProps) => (
          <Input
            isFullWidth
            id="greenpoolNotificationEmail"
            label={<Translation id="Who to notify about a new order (email)" />}
            type="email"
            placeholder="email@example.com"
            marginBottom={16}
            touched={meta.touched}
            isDisabled={isDisabled || !form.values.greenpoolTypeId}
            error={meta.error}
            {...field}
          />
        )}
      </Field>

      <Field name="greenpoolSplashText">
        {({ field, meta, form }: FieldProps) => (
          <Textarea
            isFullWidth
            id="greenpoolSplashText"
            label={<Translation id="Greenpool introduction text" />}
            placeholder={translate('Some default text for the splash message')}
            marginBottom={16}
            error={meta.error}
            touched={meta.touched}
            isDisabled={isDisabled || form.values.greenpoolTypeId !== 'OPTIONAL'}
            {...field}
          />
        )}
      </Field>

      <Field name="greenpoolConfirmationText">
        {({ field, meta, form }: FieldProps) => (
          <Textarea
            isFullWidth
            id="greenpoolConfirmationText"
            label={<Translation id="Greenpool order confirmation text" />}
            placeholder={translate('Some default text for the confirmation')}
            marginBottom={16}
            error={meta.error}
            touched={meta.touched}
            isDisabled={isDisabled || !form.values.greenpoolTypeId}
            {...field}
          />
        )}
      </Field>

      <Field name="stepGreenpoolDescription">
        {({ field, meta }: FieldProps) => (
          <Textarea
            isFullWidth
            id="stepGreenpoolDescription"
            label={<Translation id="Step Greenpool description" />}
            marginBottom={16}
            isDisabled={isDisabled}
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>
    </>
  )
}
